import publicpb from '../../base/public.pb';
import loginPb from './login.pb';
import PbAjax from '../pbajax';

let pbajax = new PbAjax();

class UserLogin {

    constructor(data = {}) {
        this.promise = this.login(data);
    }

    login(data) {
        let self = this;
        let defer = $.Deferred();
        const { Request, Response } = loginPb.User.Login;

        let businessData = new Request(data);

        let requestData = {
            https: 'true',
            service: 'safe', // java service name
            api: '/user/login' // java api
        }

        pbajax.do(
            requestData,
            businessData,
            function(res) {
                let dataWrap = publicpb.Result.decode(res);
                let data;
                
                if (dataWrap.code == 1) { // 未绑定过
                    data = Response.decode(dataWrap.data.value);

                    let userInfo = Object.assign({}, data.profile, self.parseData(data.profile));

                    defer.resolve(userInfo);
                } else {
                    defer.reject(dataWrap);
                }
            },
            () => {
                defer.reject();
            },
            () => {
                defer.reject();
            });

        return defer.promise();
    }
    /*
     * 解析数据
     */
    parseData(data) {
        let balance = data.balance || {};
        return {
            uid: this.longToString(data.uid), // 用户UID
            balance: {
                diamond: this.longToInt(balance.diamond),
                bill: this.longToInt(balance.bill),
                inBill: this.longToInt(balance.inBill),
                outDiamond: this.longToInt(balance.outDiamond)
            },
            exp: this.longToInt(data.exp), // 用户经验值
            currentExp: this.longToInt(data.currentExp), //当前级的经验值
            nextExp: this.longToInt(data.nextExp), // 距离下一级还需要多少经验值
            chatroomid: this.longToString(data.chatroomid),
            officialAuth: data.officialAuth || 0 // 大V认证标识 1是 0否
        }
    }

    longToString(value) {
        return window.longToString(value);
    }

    longToInt(value) {
        value = this.longToString(value);

        return parseInt(value, 10) || 0;
    }

}

export default UserLogin;


// WEBPACK FOOTER //
// ./js/component/openjs/deps/profile/login.js